import script from "./ExplainPageButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainPageButton.vue?vue&type=script&setup=true&lang=js"

import "./ExplainPageButton.vue?vue&type=style&index=0&id=54985d1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54985d1e"]])

export default __exports__